import * as React from 'react';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import DatePickerInputComponent from '../forms/DatePickerInput/DatePickerInputComponent';
import styled from 'styled-components';
import BorderlessButton from '../forms/Button/BorderlessButton';
import xIcon from '../../../static/img/xIcon.svg';

interface PropTypes {
  minValueProp?: Date;
  maxValueProp?: Date;
  minSelectableDate?: Date;
  maxSelectableDate?: Date;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (object: { value: any; operator: any; syntheticEvent: any }) => void;
  isFromGrid?: boolean;
}

export const DateRangeFilterCell = ({
  minValueProp,
  maxValueProp,
  onChange,
  isFromGrid = false,
  minSelectableDate,
  maxSelectableDate
}: PropTypes): JSX.Element => {
  const [minDate, setMinDate] = React.useState<Date | undefined>(minValueProp);
  const [maxDate, setMaxDate] = React.useState<Date | undefined>(maxValueProp);

  const inRange = (current, { min, max }) => (min === null || current >= min) && (max === null || current <= max);

  const handleChange = (event: InputChangeEvent, operator: string): void => {
    let maxValue = maxDate;
    let minValue = minDate;

    const utcDate = new Date(event.value).toISOString();

    if (operator === 'lte') {
      setMaxDate(new Date(utcDate));
      maxValue = new Date(utcDate);
    }
    if (operator === 'gte') {
      setMinDate(new Date(utcDate));
      minValue = new Date(utcDate);
    }

    onChange({
      value: { min: minValue, max: maxValue },
      operator: inRange,
      syntheticEvent: event.syntheticEvent,
    });
  };

  const onClearButtonClick = (event): void => {
    setMaxDate(null);
    setMinDate(null);
    event.preventDefault();
    onChange({
      value: null,
      operator: '',
      syntheticEvent: event,
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'right' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 43, textAlign: 'right' }}>
            <LabelStyle>From:</LabelStyle>
          </div>
          <div style={{ flex: 1 }}>
            <DatePickerInputComponent
              value={minDate}
              onChange={(e) => {
                handleChange(e, 'gte');
              }}
              height={25}
              cols={12}
              min={minSelectableDate}
              max={maxSelectableDate}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 43, textAlign: 'right' }}>
            <LabelStyle>To:</LabelStyle>
          </div>
          <div style={{ flex: 1 }}>
            <DatePickerInputComponent
              value={maxDate}
              onChange={(e) => {
                handleChange(e, 'lte');
              }}
              height={25}
              cols={12}
              min={minSelectableDate}
              max={maxSelectableDate}
            />
          </div>
        </div>
      </div>
      {(minDate || maxDate) && <BorderlessButton onClick={onClearButtonClick} icon={xIcon} iconSize={25} />}
    </div>
  );
};

const LabelStyle = styled.label`
  margin: 0;
  font-size: 15px;
  line-height: 17px;
  color: #b4b4b4;
  width: 100%;
`;